import { TrendingUp, TrendingDown } from 'lucide-react'

interface MetricCardProps {
  label: string
  value: string | number
  change?: string
  trend?: 'up' | 'down'
  color?: 'green' | 'red' | 'yellow'
  loading?: boolean
  onClick?: () => void
}

export function MetricCard({
  label,
  value,
  change,
  trend,
  color = 'green',
  loading = false,
  onClick,
}: MetricCardProps) {
  if (loading) {
    return (
      <div className="bg-gradient-to-br from-[#486581] to-[#102a43] p-6 rounded-xl shadow-lg animate-pulse">
        <div className="h-4 bg-[#829ab1]/30 rounded w-24 mb-2"></div>
        <div className="h-8 bg-[#829ab1]/30 rounded w-16 mb-2"></div>
        <div className="h-3 bg-[#829ab1]/30 rounded w-20"></div>
      </div>
    )
  }

  const accentColor = color === 'red' ? '#ef4444' : color === 'yellow' ? '#f59e0b' : '#10b981'
  const changeTextColor = color === 'red' ? 'text-red-400' : color === 'yellow' ? 'text-yellow-400' : 'text-[#DAA520]'

  return (
    <div
      onClick={onClick}
      style={{ borderLeftColor: accentColor }}
      className={`bg-gradient-to-br from-[#486581] to-[#102a43] p-6 rounded-xl shadow-lg hover:shadow-xl transition-all border-l-4 ${
        onClick ? 'cursor-pointer transform hover:scale-105' : ''
      }`}
    >
      <p className="text-sm text-[#bcccdc] mb-2">{label}</p>
      <div className="text-3xl mb-1 text-white font-medium">{value}</div>
      {change && (
        <div className={`text-sm flex items-center gap-1 ${changeTextColor}`}>
          {trend === 'up' ? (
            <TrendingUp className="w-3 h-3" />
          ) : trend === 'down' ? (
            <TrendingDown className="w-3 h-3" />
          ) : null}
          {change}
        </div>
      )}
    </div>
  )
}

